<div class="tab-pane show fade" id="pills-wishlist" role="tabpanel" [ngClass]="page == 'wishList' ? ' active' : ''"
  aria-labelledby="pills-wishlist-tab">
  <h1 class="page-sub-title cv-text-dark mb-4">
    <a (click)="mobileBack()" class=""><img [src]='environment1 + "assets/images/c-arrow-left.svg"'
        class="img-fluid me-2" loading="lazy" /></a>
    My Wishlist
  </h1>
  <div class="wish-list mb-3">
    <div class="row g-4">
      <ng-container *ngIf="wishlist?.length == 0 && !productLoaded ;else productTemplate">
        <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4"
          *ngFor="let item of skeletonService?.generateFake(3);let i = index;">
          <div class="poduct-item">
            <div class="d-flex align-items-center tagf">
              <ngx-skeleton height="30px" width="230px"></ngx-skeleton>
            </div>
            <div class="img-wrapper">
              <ngx-skeleton height="220px" width="230px"></ngx-skeleton>
            </div>
            <div class="d-grid gap-1 wish-content">
              <div class="cv-name text-ellipsis">
                <ngx-skeleton height="30px" width="230px"></ngx-skeleton>
              </div>
              <div class="price ">
                <ngx-skeleton height="20px" width="230px"></ngx-skeleton>
              </div>
              <div class="rating">
                <ngx-skeleton height="20px" width="230px"></ngx-skeleton>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #productTemplate>
        <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4" *ngFor="let item of wishlist | paginate: {
                      itemsPerPage: itemsPerPagewish,
                      currentPage: currentPageWishlist,
                      totalItems: totalItemsWishlist,
                      id: 'wishlist'
    }">
          <div class="poduct-item">
            <div class="d-flex align-items-center tagf">
              <span class="badge bg-primary" *ngIf="item?.is_new_launch == true"> Trending Products</span>
              <div class="like ms-auto cursor">
                <img [src]='environment1 + "assets/images/new-images/fillHeart.svg"' alt="fillHeart"
                  (click)="clickToRemove(item.id)" loading="lazy">
              </div>
            </div>
            <div class="img-wrapper">
              <a [routerLink]="redirect(item)">
                <img alt="{{item.model}}"  [src]="getUrl(item)"
                  loading="lazy" class="img-fluid cursor" />
              </a>
              <!-- <img alt="default_vehicle_img" *ngIf="!this.imageUrl" loading="lazy"
                [src]='environment1 + "assets/images/default_vehicle_img.webp"' class="img-fluid cursor" /> -->
            </div>
            <div class="d-grid gap-1 wish-content">
              <div class="cv-name text-ellipsis">
                <a style="color: black; text-decoration: none;" [routerLink]="redirect(item)">
                  {{item.model}}
                </a>
              </div>
              <div class="price" *ngIf="item?.price_range">
                {{(item?.price_range | currency:'INR':'symbol':'4.0-0')}} <span class="ex-show ps-1">Ex-showroom
                </span>
              </div>
              <div class="price" *ngIf="!item?.price_range">
                <span>Please contact to Dealer.</span>
              </div>
              <div class="rating">
                <ngx-stars [readonly]="true" [customStarIcons]="heartUrls" [color]="'#FDC602'"
                  [initialStars]="item.rating" [size]="5"></ngx-stars>
              </div>
            </div>

          </div>
        </div>
      </ng-template>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-states" *ngIf="wishlist?.length == 0">
        <img [src]='environment1 + "assets/images/no_wishlist_found.svg"' alt="no_wishlist_found" loading="lazy">
        <h3>
          Wishlist Empty
        </h3>
        <div class="desc">
          Your wishlist is currently empty. Add vehicles<br />
          to your watchlist to see them here
        </div>
      </div>
      <div class="col-xs-12 paging-custom">
        <pagination-controls class="col-xs-12" *ngIf="totalItemsWishlist > itemsPerPage"
          (pageChange)="pageChangeWishList($event)" previousLabel=" " nextLabel=" " id='wishlist'
          ></pagination-controls>
      </div>

    </div>
  </div>
</div>
